(function () {
  'use strict';

  // ─── Config ────────────────────────────────────────────────────────────────
  const CURRENCY  = 'A$';
  const DEBOUNCE  = 280;
  const MAX_PRODUCTS    = 9;
  const MAX_COLLECTIONS = 3;
  const MAX_ARTICLES    = 2;
  const MAX_SUGGESTIONS = 4;
  const MAX_BRANDS      = 4;
  const COUNT_THRESHOLD = 20;

  const SHOPIFY_FILES_BASE = 'https://cdn.shopify.com/s/files/1/0764/2402/0167/files/';
  const BRAND_LOGO_EXT     = '.png';

  // ─── Elements ──────────────────────────────────────────────────────────────
  const overlay     = document.getElementById('instant-search-overlay');
  const input       = document.getElementById('is-input');
  const clearBtn    = document.getElementById('is-clear-btn');
  const closeBtn    = document.getElementById('is-close-btn');
  const backdrop    = overlay ? overlay.querySelector('.is-backdrop') : null;

  const elEmpty     = document.getElementById('is-empty');
  const elLoading   = document.getElementById('is-loading');
  const elNoResults = document.getElementById('is-no-results');
  const elGrid      = document.getElementById('is-products-grid');
  const elViewAll   = document.getElementById('is-view-all');

  const elSuggestions        = document.getElementById('is-suggestions');
  const elSuggestionsSection = document.getElementById('is-suggestions-section');
  const elBrands             = document.getElementById('is-brands');
  const elBrandsSection      = document.getElementById('is-brands-section');
  const elCollections        = document.getElementById('is-collections');
  const elCollectionsSection = document.getElementById('is-collections-section');
  const elArticles           = document.getElementById('is-articles');
  const elArticlesSection    = document.getElementById('is-articles-section');

  if (!overlay || !input) return;

  // ─── Nuke Horizon's native search modal ────────────────────────────────────
  function nukeHorizonSearch() {
    var horizonSearch = document.querySelectorAll(
      'dialog-component#search-modal, dialog-component.search-modal, #search-modal, .search-modal, predictive-search-component, predictive-search, .predictive-search'
    );
    horizonSearch.forEach(function (el) {
      el.remove();
    });

    document.querySelectorAll('dialog[open]').forEach(function (d) {
      if (d.close) try { d.close(); } catch (e) {}
      d.removeAttribute('open');
    });

    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.removeAttribute('data-scroll-locked-by');
    document.body.classList.remove('search-modal-open', 'scroll-locked');
  }

  // ─── Open / Close ──────────────────────────────────────────────────────────
  function openSearch() {
    nukeHorizonSearch();
    overlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 50);
  }
  function closeSearch() {
    overlay.style.display = 'none';
    document.body.style.overflow = '';
  }
  function attachSearchTriggers() {
    var selectors = [
      '[data-instant-search="open"]',
      'details-modal summary[aria-haspopup="dialog"]',
      '.header__icon--search',
      'a[href="/search"]',
      'button[aria-label*="earch"]',
      'header-search-button',
      '[aria-controls*="search"]',
      'button[aria-label*="Search"]',
      'a[aria-label*="Search"]'
    ];
    document.querySelectorAll(selectors.join(',')).forEach(function (el) {
      if (el.dataset.isHooked) return;
      el.dataset.isHooked = '1';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        nukeHorizonSearch();
        openSearch();
      }, true);
    });
  }
  attachSearchTriggers();
  new MutationObserver(attachSearchTriggers).observe(document.body, { childList: true, subtree: true });

  closeBtn && closeBtn.addEventListener('click', closeSearch);
  backdrop && backdrop.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });
  clearBtn && clearBtn.addEventListener('click', function () {
    input.value = '';
    input.focus();
    resetResults();
  });

  // ─── State helpers ─────────────────────────────────────────────────────────
  function show(el)  { if (el) el.style.display = ''; }
  function hide(el)  { if (el) el.style.display = 'none'; }
  function resetResults() {
    show(elEmpty);
    hide(elLoading);
    hide(elNoResults);
    hide(elGrid);
    hide(elViewAll);
    hide(elSuggestionsSection);
    hide(elBrandsSection);
    hide(elCollectionsSection);
    hide(elArticlesSection);
    if (elGrid) elGrid.innerHTML = '';
  }
  resetResults();

  // ─── Utilities ─────────────────────────────────────────────────────────────
  function formatPrice(p) {
    if (p === null || p === undefined || p === '') return '';
    var num = parseFloat(p);
    if (isNaN(num)) return '';
    return CURRENCY + num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function getProductPrice(p) {
    if (p.price !== undefined && p.price !== null && p.price !== '') return p.price;
    if (p.price_min !== undefined && p.price_min !== null) return p.price_min;
    if (p.variants && p.variants[0] && p.variants[0].price !== undefined) return p.variants[0].price;
    return '';
  }
  function getImage(obj) {
    if (!obj) return '';
    if (obj.featured_image) {
      if (typeof obj.featured_image === 'string') return obj.featured_image;
      if (obj.featured_image.url) return obj.featured_image.url;
    }
    if (obj.image) {
      if (typeof obj.image === 'string') return obj.image;
      if (obj.image.url) return obj.image.url;
      if (obj.image.src) return obj.image.src;
    }
    if (obj.images && obj.images.length) {
      var first = obj.images[0];
      if (typeof first === 'string') return first;
      if (first && first.url) return first.url;
      if (first && first.src) return first.src;
    }
    return '';
  }
  function sizedImage(url, width) {
    if (!url) return '';
    if (url.indexOf('?') > -1) return url + '&width=' + width;
    return url + '?width=' + width;
  }
  function highlight(text, query) {
    if (!query) return escHtml(text);
    var re = new RegExp('(' + query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
    return escHtml(text).replace(re, '<strong>$1</strong>');
  }
  function escHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function escAttr(s) { return escHtml(s).replace(/'/g, '&#39;'); }
  function slugify(s) {
    return String(s).toLowerCase().replace(/[^\w\s-]/g, '').trim().replace(/[-\s]+/g, '-');
  }
  function getHandle(p) {
    if (p.handle) return p.handle;
    if (p.url) {
      var m = p.url.match(/\/products\/([^/?#]+)/);
      if (m) return m[1];
    }
    return '';
  }

  // ─── Brand logo cache ──────────────────────────────────────────────────────
  const brandLogoCache = {};
  function loadBrandCache() {
    try {
      var raw = sessionStorage.getItem('is_brand_logos_v2');
      if (raw) {
        var parsed = JSON.parse(raw);
        Object.keys(parsed).forEach(function (k) { brandLogoCache[k] = parsed[k]; });
      }
    } catch (e) {}
  }
  function saveBrandCache() {
    try { sessionStorage.setItem('is_brand_logos_v2', JSON.stringify(brandLogoCache)); } catch (e) {}
  }
  loadBrandCache();

  function tryLoadImage(url) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () { resolve(url); };
      img.onerror = function () { resolve(''); };
      img.src = url;
    });
  }
  function fetchBrandLogo(vendorName) {
    var key = vendorName.toLowerCase();
    if (brandLogoCache[key] !== undefined) return Promise.resolve(brandLogoCache[key]);
    var slug = slugify(vendorName);
    var filesUrl = SHOPIFY_FILES_BASE + slug + BRAND_LOGO_EXT;
    return tryLoadImage(filesUrl).then(function (validUrl) {
      if (validUrl) {
        brandLogoCache[key] = validUrl;
        saveBrandCache();
        return validUrl;
      }
      return fetch('/collections/' + slug + '.json')
        .then(function (res) { if (!res.ok) throw new Error('not found'); return res.json(); })
        .then(function (data) {
          var img = data && data.collection ? (getImage(data.collection) || '') : '';
          brandLogoCache[key] = img;
          saveBrandCache();
          return img;
        })
        .catch(function () {
          brandLogoCache[key] = '';
          saveBrandCache();
          return '';
        });
    });
  }

  // ─── Product details cache ─────────────────────────────────────────────────
  const productInfoCache = {};
  function loadInfoCache() {
    try {
      var raw = sessionStorage.getItem('is_product_info_v4');
      if (raw) {
        var parsed = JSON.parse(raw);
        Object.keys(parsed).forEach(function (k) { productInfoCache[k] = parsed[k]; });
      }
    } catch (e) {}
  }
  function saveInfoCache() {
    try { sessionStorage.setItem('is_product_info_v4', JSON.stringify(productInfoCache)); } catch (e) {}
  }
  loadInfoCache();

  function fetchSku(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (data && data.variants && data.variants[0] && data.variants[0].sku) {
          return data.variants[0].sku;
        }
        return '';
      })
      .catch(function () { return ''; });
  }

  function scrapeStock(handle) {
    return fetch('/products/' + handle)
      .then(function (res) { return res.ok ? res.text() : ''; })
      .then(function (html) {
        if (!html) return { status: 'unknown', label: '' };
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var result = { status: 'unknown', label: '' };
        var stockEl = doc.querySelector('#stock-status .stock-status');
        if (stockEl) {
          var cls = stockEl.className || '';
          if (cls.indexOf('in-stocks') > -1 || cls.indexOf('in-stock') > -1) result.status = 'in';
          else if (cls.indexOf('out-of-stocks') > -1 || cls.indexOf('out-of-stock') > -1 || cls.indexOf('sold-out') > -1) result.status = 'out';
        }
        if (result.status === 'unknown') {
          var shipEl = doc.querySelector('#stock-status .shipping-date-info, .shipping-date-info');
          if (shipEl) result.status = 'shipping';
        }
        var misc2 = doc.querySelector('#stock-status input.misc2-value, .misc2-value');
        if (misc2) {
          var v = misc2.getAttribute('value') || misc2.value || '';
          if (v) result.label = v.trim();
        }
        if (result.status === 'unknown') {
          var allStockText = '';
          var statusContainer = doc.querySelector('#stock-status');
          if (statusContainer) allStockText = (statusContainer.textContent || '').toLowerCase();
          if (/in[\s-]?stock/.test(allStockText)) result.status = 'in';
          else if (/out[\s-]?of[\s-]?stock|sold[\s-]?out/.test(allStockText)) result.status = 'out';
          else if (/ships?\s+in/.test(allStockText) || result.label) result.status = 'shipping';
        }
        return result;
      })
      .catch(function () { return { status: 'unknown', label: '' }; });
  }

  function fetchProductInfo(handle) {
    if (!handle) return Promise.resolve(null);
    if (productInfoCache[handle] !== undefined) return Promise.resolve(productInfoCache[handle]);
    return Promise.all([fetchSku(handle), scrapeStock(handle)])
      .then(function (results) {
        var info = { sku: results[0], status: results[1].status, label: results[1].label };
        productInfoCache[handle] = info;
        saveInfoCache();
        return info;
      })
      .catch(function () {
        var info = { sku: '', status: 'unknown', label: '' };
        productInfoCache[handle] = info;
        return info;
      });
  }

  // ─── Brand count cache ─────────────────────────────────────────────────────
  const brandCountCache = {};
  function fetchBrandCount(query, vendor) {
    var key = query.toLowerCase() + '||' + vendor.toLowerCase();
    if (brandCountCache[key] !== undefined) return Promise.resolve(brandCountCache[key]);
    var combinedQuery = query + ' ' + vendor;
    var url = '/search/suggest.json?q=' + encodeURIComponent(combinedQuery)
      + '&resources[type]=product&resources[limit]=10'
      + '&resources[options][unavailable_products]=last'
      + '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';
    return fetch(url)
      .then(function (res) { if (!res.ok) throw new Error('not found'); return res.json(); })
      .then(function (data) {
        var products = (((data || {}).resources || {}).results || {}).products || [];
        var count = 0;
        var vendorLower = vendor.toLowerCase();
        products.forEach(function (p) { if (p.vendor && p.vendor.toLowerCase() === vendorLower) count++; });
        var display;
        if (products.length >= 10) display = count >= COUNT_THRESHOLD ? (COUNT_THRESHOLD + '+') : (count + '+');
        else display = count;
        brandCountCache[key] = display;
        return display;
      })
      .catch(function () { brandCountCache[key] = ''; return ''; });
  }

  // ─── Suggestions / Brands ──────────────────────────────────────────────────
  function buildSuggestions(products, query) {
    var seen = {}; var words = [];
    products.forEach(function (p) {
      p.title.split(/\s+/).forEach(function (w) {
        var lw = w.toLowerCase();
        if (!seen[lw] && lw.startsWith(query.toLowerCase()) && lw !== query.toLowerCase()) {
          seen[lw] = true; words.push(w);
        }
      });
    });
    return [query].concat(words.slice(0, MAX_SUGGESTIONS - 1));
  }
  function buildBrands(products) {
    var map = {};
    products.forEach(function (p) { if (p.vendor) map[p.vendor] = (map[p.vendor] || 0) + 1; });
    return Object.keys(map).map(function (v) { return { name: v, count: map[v] }; })
      .sort(function (a, b) { return b.count - a.count; }).slice(0, MAX_BRANDS);
  }
  function brandInitials(name) {
    var first = String(name).split(/\s+/)[0] || '';
    return first.substring(0, 5).toUpperCase();
  }

  const PLACEHOLDER_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>';
  const CHECK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

  function stockBadgeHtml(status, label) {
    if (status === 'in') return '<span class="is-stock-badge is-in-stock">' + CHECK_SVG + ' In Stock</span>';
    if (status === 'out') return '<span class="is-stock-badge is-out-stock">Out of Stock</span>';
    if (status === 'shipping') {
      var text = label ? escHtml(label) : 'Ships Soon';
      return '<span class="is-stock-badge is-shipping">' + text + '</span>';
    }
    return '<span class="is-stock-badge-placeholder"></span>';
  }

  function renderBrands(brands, query) {
    if (!brands.length) { hide(elBrandsSection); return; }
    show(elBrandsSection);
    elBrands.innerHTML = brands.map(function (b, i) {
      var slug = slugify(b.name); var key = b.name.toLowerCase();
      var cached = brandLogoCache[key]; var logoHtml;
      if (cached) logoHtml = '<img class="is-brand-logo" src="' + escAttr(cached) + '" alt="" />';
      else if (cached === '') logoHtml = '<div class="is-brand-logo-fallback">' + escHtml(brandInitials(b.name)) + '</div>';
      else logoHtml = '<div class="is-brand-logo-fallback" data-brand-slot="' + i + '">' + escHtml(brandInitials(b.name)) + '</div>';
      return '<a class="is-brand" href="/collections/' + escAttr(slug) + '">' + logoHtml
        + '<span class="is-brand-name">' + escHtml(b.name) + '</span>'
        + '<span class="is-brand-count" data-count-slot="' + i + '">(' + b.count + ')</span></a>';
    }).join('');
    brands.forEach(function (b, i) {
      var key = b.name.toLowerCase();
      if (brandLogoCache[key] === undefined) {
        fetchBrandLogo(b.name).then(function (logoUrl) {
          if (!logoUrl) return;
          var slot = elBrands.querySelector('[data-brand-slot="' + i + '"]');
          if (slot) slot.outerHTML = '<img class="is-brand-logo" src="' + escAttr(logoUrl) + '" alt="" />';
        });
      }
      fetchBrandCount(query, b.name).then(function (realCount) {
        if (realCount === '' || realCount === undefined) return;
        var slot = elBrands.querySelector('[data-count-slot="' + i + '"]');
        if (slot) slot.textContent = '(' + realCount + ')';
      });
    });
  }

  function renderSidebar(products, collections, articles, query) {
    var suggestions = buildSuggestions(products, query);
    if (suggestions.length) {
      elSuggestions.innerHTML = suggestions.map(function (s, i) {
        var encoded = encodeURIComponent(s);
        return '<a class="is-suggestion" href="/search?q=' + encoded + '">'
          + (i === 0 ? '<strong>' + escHtml(s) + '</strong>' : highlight(s, query)) + '</a>';
      }).join('');
      show(elSuggestionsSection);
    } else hide(elSuggestionsSection);
    renderBrands(buildBrands(products), query);
    if (collections && collections.length) {
      elCollections.innerHTML = collections.slice(0, MAX_COLLECTIONS).map(function (c) {
        var imgUrl = getImage(c);
        var thumb = imgUrl
          ? '<img class="is-collection-thumb" src="' + escAttr(sizedImage(imgUrl, 60)) + '" alt="" onerror="this.style.display=\'none\'" />'
          : '<div class="is-collection-thumb" style="background:#333;display:flex;align-items:center;justify-content:center;font-size:11px;color:#888;">' + escHtml(c.title.charAt(0)) + '</div>';
        return '<a class="is-collection" href="' + escAttr(c.url) + '">' + thumb + '<span>' + highlight(c.title, query) + '</span></a>';
      }).join('');
      show(elCollectionsSection);
    } else hide(elCollectionsSection);
    if (articles && articles.length) {
      elArticles.innerHTML = articles.slice(0, MAX_ARTICLES).map(function (a) {
        var imgUrl = getImage(a);
        var thumb = imgUrl
          ? '<img class="is-article-thumb" src="' + escAttr(sizedImage(imgUrl, 80)) + '" alt="" onerror="this.style.display=\'none\'" />'
          : '<div class="is-article-thumb" style="background:#333;"></div>';
        return '<a class="is-article" href="' + escAttr(a.url) + '">' + thumb + '<span class="is-article-title">' + highlight(a.title, query) + '</span></a>';
      }).join('');
      show(elArticlesSection);
    } else hide(elArticlesSection);
  }

  function renderProducts(products, query) {
    if (!products.length) return;
    elGrid.innerHTML = products.slice(0, MAX_PRODUCTS).map(function (p, i) {
      var imgUrl = getImage(p);
      var img = imgUrl
        ? '<img class="is-product-img" src="' + escAttr(sizedImage(imgUrl, 140)) + '" alt="" onerror="this.style.display=\'none\'" />'
        : '<div class="is-product-img-placeholder">' + PLACEHOLDER_SVG + '</div>';
      var priceVal = getProductPrice(p); var price = formatPrice(priceVal);
      var handle = getHandle(p); var cached = productInfoCache[handle];
      var sku = '';
      if (p.variants && p.variants[0] && p.variants[0].sku) sku = p.variants[0].sku;
      if (!sku && cached && cached.sku) sku = cached.sku;
      var status = cached && cached.status ? cached.status : 'unknown';
      var label = cached && cached.label ? cached.label : '';
      var skuHtml = sku
        ? '<span class="is-product-sku">SKU: ' + escHtml(sku) + '</span>'
        : '<span class="is-product-sku" data-sku-slot="' + i + '"></span>';
      var stockHtml = '<span data-stock-slot="' + i + '">' + stockBadgeHtml(status, label) + '</span>';
      return '<a class="is-product-card" href="' + escAttr(p.url) + '">' + img
        + '<div class="is-product-info">'
        + '<p class="is-product-title">' + highlight(p.title, query) + '</p>'
        + (p.vendor ? '<p class="is-product-vendor">' + escHtml(p.vendor) + '</p>' : '')
        + (price ? '<p class="is-product-price">' + price + '</p>' : '')
        + '<div class="is-product-meta">' + skuHtml + stockHtml + '</div></div></a>';
    }).join('');
    products.slice(0, MAX_PRODUCTS).forEach(function (p, i) {
      var handle = getHandle(p); if (!handle) return;
      fetchProductInfo(handle).then(function (info) {
        if (!info) return;
        var skuSlot = elGrid.querySelector('[data-sku-slot="' + i + '"]');
        if (skuSlot && info.sku && !skuSlot.textContent) skuSlot.textContent = 'SKU: ' + info.sku;
        var stockSlot = elGrid.querySelector('[data-stock-slot="' + i + '"]');
        if (stockSlot) stockSlot.innerHTML = stockBadgeHtml(info.status, info.label);
      });
    });
  }

  var debounceTimer; var lastQuery = '';
  input.addEventListener('input', function () {
    var q = input.value.trim();
    if (q === lastQuery) return;
    lastQuery = q;
    clearTimeout(debounceTimer);
    if (!q) { resetResults(); return; }
    debounceTimer = setTimeout(function () { performSearch(q); }, DEBOUNCE);
  });

  function performSearch(q) {
    hide(elEmpty); hide(elNoResults); hide(elGrid); hide(elViewAll);
    hide(elSuggestionsSection); hide(elBrandsSection);
    hide(elCollectionsSection); hide(elArticlesSection);
    show(elLoading);
    var url = '/search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product,collection,article&resources[limit]=10'
      + '&resources[options][unavailable_products]=last'
      + '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        hide(elLoading);
        var resources = (data.resources && data.resources.results) || {};
        var products = resources.products || [];
        var collections = resources.collections || [];
        var articles = resources.articles || [];
        if (!products.length && !collections.length && !articles.length) { show(elNoResults); return; }
        renderSidebar(products, collections, articles, q);
        if (products.length) {
          renderProducts(products, q);
          show(elGrid);
          elViewAll.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
          show(elViewAll);
        }
      })
      .catch(function () { hide(elLoading); show(elNoResults); });
  }

  window.instantSearch = { open: openSearch, close: closeSearch };
})();